import React from 'react';
import "../less/quick-cash-business.less"
import hero_img from '../img/hero_img.png';
import Advantages from '../../../../../auxiliary-components/shared/AdvantagesBlock';
import advantages_img_1 from '../img/advantages_img_1.png';
import advantages_img_2 from '../img/advantages_img_2.png';
import advantages_img_3 from '../img/advantages_img_3.png';
import QuestionsAdminNew from '../../../../../auxiliary-components/shared/QuestionsAdminNew';
import FilesForDownloadNew from "../../../../../auxiliary-components/shared/FilesForDownloadNew";
import FAQStorybook from '@abank/abank-faq';
import CalculatorNew from '../../../../../auxiliary-components/CalculatorNew';
import Tabs from '../../../../../auxiliary-components/shared/Tabs';
import HowToBlockNew from '../../../../../auxiliary-components/shared/HowToBlockNew';
import how_to_block_img_1 from '../img/how_to_block_img_1.png';
import how_to_block_img_2 from '../img/how_to_block_img_2.png';
import how_to_block_img_3 from '../img/how_to_block_img_3.png';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import QuickCashOrder from "../../../../QuickCashOrder";
import howToBlockItemsData from '../enums/how_to_block_items.json';
import advantagesItemsData from '../enums/advantages_items.json';
import { Preloader } from 'MWComponents';
import hero_data from '../enums/hero_data.json';
import { a24QuickCashLink } from '../../../../../services/urls/urls';
import { getSafeLinkProps } from './../../../../../helpers/utils/urlSecurity';
import DOMPurify from 'utils/sanitize';
import { filterByEnvironment } from '../../../../../helpers/utils/environmentFilter';

export default function template() {
    const page = 'business-quick-cash';
    const isMobile = this.isViewportMobile();
    const model = this.getModel();

    const imagesMap = {
      how_to_block_img_1,
      how_to_block_img_2,
      how_to_block_img_3,
      advantages_img_1,
      advantages_img_2,
      advantages_img_3
    };

    const handlersMap = {
      toggleHeroModal: () => this.toggleModal(false)
    };

    const howToBlockItems = howToBlockItemsData.map(item => ({
      ...item,
      img: imagesMap[item.img]
    }));

    const advantagesItems = advantagesItemsData.map(item => ({
      ...item,
      img: imagesMap[item.img]
    }));

    const tabs = [
      {tab: 'calculator', title: 'BUSINESS_QUICK_CASH_TABS_INFO_TITLE_01'},
      {tab: 'get-services', title: 'BUSINESS_QUICK_CASH_TABS_INFO_TITLE_02'},
      {tab: 'payments', title: 'BUSINESS_QUICK_CASH_TABS_INFO_TITLE_03'}
    ];

    const heroData = {
      ...hero_data,
      link: {
        ...hero_data.link,
        onClick: handlersMap[hero_data.link.onClick],
      },
    };

    const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

    return (
        <div className="module-business-quick-cash">
          <Hero
            data={heroData}
            img={hero_img}
          />
          <div className="content">
            {!this.state.faqTab ? (
              <>
              <Advantages
                items={advantagesItems}
                title={'BUSINESS_QUICK_CASH_ADVANTAGES_TITLE'}
              />
              <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab}>
                {model.creditSum ? (
                  <CalculatorNew model={model} type={"quick_cash_business"} toggleModal={this.toggleModal} isBtn={true} {...this.props} tab={this.state.tab}/>
                ) : <Preloader />}
                <HowToBlockNew
                  items={howToBlockItems}
                  title={'BUSINESS_QUICK_CASH_HOW_TO_TITLE'}
                />
                <div className="make-payment">
                  <div className="container">
                    <div className="make-payment__body">
                      <div className="make-payment__item item-make-payment">
                        <div className="item-make-payment__title">{this.l10n('BUSINESS_QUICK_CASH_MAKE_PAYMENT_TITLE_01')}</div>
                        <div className="item-make-payment__text">
                          <ul>
                            <li>{this.l10n('BUSINESS_QUICK_CASH_MAKE_PAYMENT_ITEM_01_LIST_01')}</li>
                            <li>{this.l10n('BUSINESS_QUICK_CASH_MAKE_PAYMENT_ITEM_01_LIST_02')}</li>
                          </ul>
                          <p>{this.l10n('BUSINESS_QUICK_CASH_MAKE_PAYMENT_ITEM_01_TEXT')}</p>
                        </div>
                      </div>
                      <div className="make-payment__item item-make-payment">
                        <div className="item-make-payment__title">{this.l10n('BUSINESS_QUICK_CASH_MAKE_PAYMENT_TITLE_02')}</div>
                        <div className="item-make-payment__text">
                          <ol>
                            <li><span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('BUSINESS_QUICK_CASH_MAKE_PAYMENT_ITEM_02_LIST_01'))}}></span> <a {...getSafeLinkProps('/branches', {navigate: this.navigate})}>{this.l10n('BUSINESS_QUICK_CASH_MAKE_PAYMENT_ITEM_02_LINK_01')}</a></li>
                            <li><span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('BUSINESS_QUICK_CASH_MAKE_PAYMENT_ITEM_02_LIST_02'))}}></span> <a {...getSafeLinkProps(a24QuickCashLink)}>{this.l10n('BUSINESS_QUICK_CASH_MAKE_PAYMENT_ITEM_02_LINK_02')}</a></li>
                            <li><span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('BUSINESS_QUICK_CASH_MAKE_PAYMENT_ITEM_02_LIST_03'))}}></span></li>
                          </ol>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tabs>
              <QuestionsAdminNew
                widget={questionsWidget}
                toggleFaqTab={this.toggleFaqTab}
                title={'BUSINESS_QUICK_CASH_QUESTIONS_TITLE'}
              />
              <FilesForDownloadNew
                widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
              />
            </>
            ) : (
              <FAQStorybook
                widget={questionsWidget}
                title={this.l10n('BUSINESS_QUICK_CASH_FAQ_STORYBOOK_TITLE')}
                btnText={this.l10n('BUSINESS_QUICK_CASH_FAQ_STORYBOOK_BTN_TEXT')}
                onBtnClick={this.toggleFaqTab}
                filterByEnvironment={filterByEnvironment}
              />
            )}
          </div>
          {this.state.showModal &&
            <QuickCashOrder
              closeModal={this.toggleModal}
              utmParams={this.utmParams}
              isMobile={isMobile}
              loanTerm={this.state.loanTerm}
              loanSum={this.state.loanSum}
            />
          }
        </div>
    );
}
